/* zenz-areal - skjuler arealbadgen naar hele tittelen (inkl. areal) faktisk
   er synlig i kortet, saa arealet aldri vises dobbelt. Badgen ligger alltid
   rett etter tittel-elementet (previousElementSibling). */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .replace(/kvm|m²|m2/g, 'm2')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function truncated(el) {
    if (!el) return false;
    if (el.scrollHeight > el.clientHeight + 2) return true;
    for (var i = 0; i < el.children.length; i++) {
      if (truncated(el.children[i])) return true;
    }
    return false;
  }

  function apply() {
    var badges = document.querySelectorAll('[data-zz-areal]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var t = b.previousElementSibling;
      if (!t) continue;
      var visibleInTitle =
        !truncated(t) && norm(t.textContent).indexOf(norm(b.textContent)) !== -1;
      if (visibleInTitle) {
        b.setAttribute('hidden', 'hidden');
      } else {
        b.removeAttribute('hidden');
      }
    }
  }

  var deb;
  function onResize() {
    clearTimeout(deb);
    deb = setTimeout(apply, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('resize', onResize);
  /* Grid-innhold kan komme via AJAX (filtrering/paginering) - kjoer ogsaa da. */
  document.addEventListener('shopify:section:load', apply);
})();
